import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import historyReducer from './historySlice';
import stepReducer from './stepSlice';
import schemaReducer from './schemaSlice';
import keyFieldsReducer from './keyFieldsSlice';

export const store = configureStore({
  reducer: {
    history: historyReducer,
    step: stepReducer,
    schema: schemaReducer,
    keyFields: keyFieldsReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
